import { useState } from 'react';

import { useAtomValue } from 'jotai';

import { openFolderIdAtom } from '../../store/fileSystem.js';

/**
 * For pickers over the knowledge base: start where the page is, then browse
 * on their own, so choosing a folder never moves the page's view.
 */
export const useBrowsedFolderId = () => {
  const openFolderId = useAtomValue(openFolderIdAtom);

  return useState(openFolderId);
};
